import { APP_STORAGE_ID, ENABLE_LOGGING } from "../_game/config/Game";
import { __SoundManager } from "./core";
// import {  __Proxi, __ProxiProvider } from "./core";

interface LocalStorageInterface {
  MUTE_SFX: boolean;
  MUTE_BG: boolean;
  VOLUME_SFX: number;
  VOLUME_MUSIC: number;

  SESSION_ID: string;

  SPACE_TO_SPIN: boolean;
  FAST_SPIN: boolean;
  INTRO_SCREEN: boolean;
  AUTO_STOP_AT_WIN: boolean;
  BATTERY_SAVER: boolean;
}

class LocalStorage {
  private lState: LocalStorageInterface;

  constructor() {
    this.lState = {
      MUTE_SFX: false,
      MUTE_BG: false,
      VOLUME_SFX: 1.0,
      VOLUME_MUSIC: 1.0,
      // used for SpearHead when reloading the game to skip the OPEN call (disconnect usually)
      SESSION_ID: '',
      //#TODO: use these to save gameplay settings too
      SPACE_TO_SPIN: true,
      FAST_SPIN: false,
      INTRO_SCREEN: true,
      AUTO_STOP_AT_WIN: false,
      BATTERY_SAVER: false,
    }

		this.loadSettings();
  }

  isEnabled (): boolean {
    var tmpkey = 'fltmpkey';
    if (typeof Storage === 'undefined') {
      return false;
    }
  
    try {
      localStorage.setItem(tmpkey, tmpkey);
      localStorage.removeItem(tmpkey);
      return true;
    } catch (e) {
      return false;
    }
  }

  loadSettings(_data?: any): void {
    if(!this.isEnabled) {
      this.LOG(' > Settings Loading Failed: Local storage disabled!');
      return;
    }
    const dataLoaded = localStorage.getItem(APP_STORAGE_ID);
    
    if (dataLoaded !== null) {
      const loadedData = JSON.parse(dataLoaded);
      if (loadedData) {
        this.lState = {
          ...this.lState,
          ...loadedData,
        };
      }
  
      this.LOG(' > Settings Loaded:' + JSON.stringify(this.lState));
    }
  }

  saveSettings() {
    // don't try to load if storage is disabled
    if (this.isEnabled() === false) {
      this.LOG(' > Settings Saving Failed: Local storage disabled!');
      return;
    }

    localStorage.setItem(APP_STORAGE_ID, JSON.stringify(this.lState));
   
    this.LOG(' > Settings Saved:' + JSON.stringify(this.lState));
  }

  get state() {
    return this.lState;
  }

  setBatterySaver(_boolean: boolean) {
    this.lState.BATTERY_SAVER = _boolean;
    this.saveSettings();
  }
 
  setAutoStopAtWin(_boolean: boolean) {
    this.lState.AUTO_STOP_AT_WIN = _boolean;
    this.saveSettings();
  }

  setIntroScreen(_boolean: boolean) {
    this.lState.INTRO_SCREEN = _boolean;
    this.saveSettings();
  }

  isGlobalMuted(): boolean {
    return this.lState.MUTE_SFX && this.lState.MUTE_BG;
  }
 
  LOG(message: string) {
    if(!ENABLE_LOGGING) return;

    console.groupCollapsed(
      '%c LOCAL STORAGE                     ',
      'background: #1e6ea0; color: white; display: block;',
    );

    console.log(message);
		console.groupEnd();
  }


	setVolumeMusic(_volume: any) {
    this.lState.VOLUME_SFX = _volume; 
   __SoundManager.setVolume('sfx', _volume);

   this.saveSettings(); 
  }


  muteSoundsBG(_boolean: boolean) {
    this.lState.MUTE_BG = _boolean; 
    __SoundManager.muteChannel('music', _boolean);

		this.saveSettings();
  }

  muteSoundsSFX(_boolean: boolean) {
    this.lState.MUTE_SFX = _boolean;
    __SoundManager.muteChannel('sfx', _boolean);
 
     this.saveSettings();
  }
}

export default LocalStorage;